import React from "react";
import "./AboutCompany.css";
import TeamSection from "./TeamSection";
import { motion } from "framer-motion"; // You'll need to install framer-motion
import CountUp from "react-countup"; // You'll need to install react-countup
import { FaTruck, FaMapMarkedAlt, FaHandshake } from "react-icons/fa"; // You'll need to install react-icons

const AboutCompany = () => {
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8, ease: "easeOut" },
  };

  const pageTransition = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 1.2, ease: "easeInOut" },
  };

  return (
    <motion.div className="about-page" {...pageTransition}>
      <div className="about-container">
        <motion.div
          className="about-us-section"
          variants={fadeIn}
          initial="initial"
          animate="animate"
        >
          <h3 className="section-title">About Us</h3>
          <motion.div
            className="about-us-content"
            whileHover={{ scale: 1.01 }}
            transition={{ type: "spring", stiffness: 200 }}
          >
            <p className="about-us-text">
              We are India's premier GPS-based fleet management provider,
              revolutionizing transportation with innovative technology and deep
              industry expertise. Our advanced tracking systems and dedicated
              support ensure peak fleet efficiency through real-time monitoring,
              analytics, and bespoke solutions tailored to each client's unique
              needs. Committed to integrity, transparency, and accountability,
              we build lasting relationships based on trust and mutual respect,
              positioning ourselves as the trusted partner for businesses
              seeking to optimize their fleet operations.
            </p>
          </motion.div>
        </motion.div>
        <motion.div
          className="about-content"
          variants={fadeIn}
          initial="initial"
          animate="animate"
        >
          <motion.h1
            className="about-title"
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <span className="highlight">
              Digital Logistics, Connected Fleet, Supply Chain Optimisation
            </span>
          </motion.h1>

          {/* <motion.h2
            className="about-subtitle"
            variants={fadeIn}
            whileHover={{ scale: 1.02 }}
          >
            "Revolutionizing Fleet Management Across India with Cutting-Edge GPS
            Technology"
          </motion.h2> */}

          <div className="stats-container">
            <motion.div
              className="stat-card"
              whileHover={{
                scale: 1.05,
                boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
                backgroundColor: "#f8f9fa",
              }}
            >
              <FaTruck className="stat-icon" />
              <div className="stat-number">
                <CountUp
                  end={12000}
                  duration={2.5}
                  separator=","
                  className="counter-text"
                />
                <span className="plus-symbol">+</span>
              </div>
              <p className="stat-label">Active Vehicles</p>
              <p className="stat-subtitle">Across the Nation</p>
            </motion.div>

            <motion.div
              className="stat-card"
              whileHover={{
                scale: 1.05,
                boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
                backgroundColor: "#f8f9fa",
              }}
            >
              <FaMapMarkedAlt className="stat-icon" />
              <div className="stat-number">
                <CountUp end={5} duration={2.5} className="counter-text" />
                <span className="plus-symbol">+</span>
              </div>
              <p className="stat-label">Major States</p>
              <p className="stat-subtitle">And Growing</p>
            </motion.div>

            <motion.div
              className="stat-card"
              whileHover={{
                scale: 1.05,
                boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
                backgroundColor: "#f8f9fa",
              }}
            >
              <FaHandshake className="stat-icon" />
              <div className="stat-number">
                <span className="support-text">24/7</span>
              </div>
              <p className="stat-label">Customer Support</p>
              <p className="stat-subtitle">Always Available</p>
            </motion.div>
          </div>

          <motion.div className="states-grid" variants={fadeIn}>
            {[
              "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar",
              "Chhattisgarh", "Goa", "Gujarat", "Haryana",
              "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala",
              "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya",
              "Mizoram", "Nagaland", "Odisha", "Punjab",
              "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana",
              "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"
            ].map(
              (state, index) => (
                <motion.div
                  key={state}
                  className="state-card"
                  whileHover={{
                    scale: 1.1,
                    backgroundColor: "#0056b3",
                    color: "white",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                  }}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  <span className="state-name">{state}</span>
                  <span className="state-info">Full Coverage</span>
                </motion.div>
              )
            )}
          </motion.div>

          <motion.div className="vision-section" variants={fadeIn}>
            <h3 className="vision-title">Our Vision</h3>
            <motion.p className="vision-text" whileHover={{ scale: 1.02 }}>
              We are committed to delivering unparalleled quality services to
              our clients through innovative GPS-based fleet management
              solutions. With dedicated on-ground sales and service support
              teams across the country, we ensure seamless operations and
              maximum customer satisfaction.
            </motion.p>
          </motion.div>
        </motion.div>
      </div>

      <TeamSection />
    </motion.div>
  );
};

export default AboutCompany;
